import { Component } from '@angular/core';

@Component({
  selector: 'app-product-box-icon',
  imports: [],
  templateUrl: './product-box-icon.html',
  styleUrl: './product-box-icon.scss',
})
export class ProductBoxIcon {

}
